import Vue from 'vue'
import VueI18n from 'vue-i18n'
import VueCookies from 'vue-cookies'
import languages from "@/locale/languages";

Vue.use(VueCookies)
Vue.use(VueI18n)

VueI18n.prototype.getChoiceIndex = function (choice, choicesLength) {
    if (choice === 1) {
        return 0
    }
    if (!Number.isInteger(choice)) {
        return 3
    }
    if ([0, 1, 5, 6, 7, 8, 9].includes(choice % 10) || [11, 12, 13, 14].includes(choice % 100)) {
        return 2
    }
    if ([2, 3, 4].includes(choice % 10)) {
        return 1
    }
}

let domLocale = document.getElementById("locale")
let pdfLocale = domLocale ? domLocale.getAttribute("data-name") : null

export default new VueI18n({
    locale: Vue.$cookies.get('locale') || pdfLocale || window.navigator.language.substring(0, 2),
    fallbackLocale: 'en',
    messages: Object.assign(languages)
})
